import { IResponseData } from '../stores/types';
export function logPageLoad(state: IResponseData): void {
    const apiUrl = state?.contextData?.apiLink + 'productdetailspage/pageload';
    const requestUrl = new URL(apiUrl);
    const customerNumber = state.contextData.customerData?.customerNumbers?.length > 0 ?
        state.contextData.customerData.customerNumbers[0] : null;
    const body = {
        articleInfo: state.orderModule.articleInfo,
        category: state.breadcrumb.category,
        customerNumber: customerNumber
    };

    // Append all query parameters from the current browser URL
    if (typeof window !== 'undefined') {
        const currentUrl = new URL(window.location.href);

        currentUrl.searchParams.forEach((value, key) => {
            requestUrl.searchParams.append(key, value);
        });
    }

    fetch(requestUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body)
    }).catch(() => { /* ignore */ });
}

export function cleanupUrl(): void {
    const meta = document.querySelector<HTMLMetaElement>(
        'meta[name="hidden-query-params"]'
    );

    if (meta) {
        const paramsToRemove = meta.content.split(',').map(param => param.trim()).filter(Boolean);
        const url = new URL(window.location.href);

        paramsToRemove.forEach(param => {
            url.searchParams.delete(param);
        });

        const relativeUrl = `${url.pathname}${url.search}${url.hash}`;
        window.history.replaceState({}, document.title, relativeUrl);
    }
}
